export const fromParamUtils = (url: string | null): string | null => {
    if (!url) return null;

    const urlObj = new URL(url);
    return urlObj.searchParams.get('from');
};

// check if the job is from mobweb hp, react-native app hp or desktop hp
export const isJobFromHomePage = (from: string | undefined | null): boolean => {
    // from can be hp for viewJobLink url and hp.* or hpd.* for the viewJob url after the job click redirect
    return from?.startsWith('hp') ?? false;
};

// check if the job is from serp
export const isJobFromSerp = (from: string | undefined | null): boolean => {
    return (from?.startsWith('serp') || from?.startsWith('tp-serp')) ?? false;
};

// Web (rawclick surface) variant of `isJobFromHomePage`. Broader than the shared
// helper: the desktop two-pane auto-open job overrides `from` to `mobhp_jobfeed_auto`.
export const isJobFromHomePageWeb = (from: string | undefined | null): boolean => {
    return (from?.startsWith('hp') || from?.startsWith('mobhp')) ?? false;
};

// Web (rawclick surface) variant of `isJobFromSerp`. Broader than the shared
// helper: also matches third-party serp (`tp-`) and the `vjs` source.
export const isJobFromSerpWeb = (from: string | undefined | null): boolean => {
    return (from?.startsWith('serp') || from?.startsWith('tp-') || from === 'vjs') ?? false;
};
